// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"buttonlang_Wrapper__3ujvn","Eng":"buttonlang_Eng__1Rh_a","Id":"buttonlang_Id__1T1oS","Active":"buttonlang_Active__1RA8Z"};